import {useEffect, useCallback} from 'react';

export const useYVisible = ({verticalScroll, ref, isSelected, patternSelected, bottomMode}) => {
    useEffect(() => {
        if (!isSelected ||
            !verticalScroll ||
            !ref ||
            !verticalScroll.current ||
            !ref.current) {
            return;
        }

        // check if visible
        let scrollTop = verticalScroll.current.scrollTop;
        let scrollHeight = verticalScroll.current.offsetHeight;
        let scrollBottom = scrollTop + scrollHeight;

        let top = ref.current.offsetTop;
        let bottom = top + ref.current.offsetHeight;

        if (top < scrollTop || bottom > scrollBottom) {
            // then we need to scroll
            verticalScroll.current.scrollTo(0, top - 150);
        }
    }, [isSelected, ref, verticalScroll]);
};
